import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";

//Registration schema
const schema = yup.object().shape({
    school: yup.string().required("School Name is a required field"),
    session: yup.string().required("Session is a required field"),
    term: yup.string().required("Term is a required field"),
});

const AdminSchoolSettings = () => {
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];

    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];

    const {
        handleSubmit,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            System Settings
                        </Heading>
                        <Breadcrumb
                            crumbs={['System-Settings', 'School Details Update']}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="SCHOOL"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="SCHOOL"
                                                type="text"
                                                label="SCHOOL Name"
                                                placeholder="Select school"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.school?.message}
                                                options={classOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="session"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="session"
                                                type="text"
                                                label='session'
                                                placeholder="Select session"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.session?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Controller
                                    control={control}
                                    name="term"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="term"
                                                type="text"
                                                label='term'
                                                placeholder="Select term"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.term?.message}
                                                options={subjectOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                ADD
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default AdminSchoolSettings
